import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  EnvironmentProviders,
  Provider,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { authInterceptor } from 'app/core/auth/auth.interceptor';
import { CasdoorAuthService } from 'app/core/auth/casdoor-auth.service';
import { environment } from 'environments/environment';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideHttpClient(withInterceptors([authInterceptor])),
        CasdoorAuthService, // Fournir le service Casdoor
        provideEnvironmentInitializer(() => {
            const casdoorAuth = inject(CasdoorAuthService);
            // Initialiser l'authentification au démarrage
            return Promise.resolve();
        }),
    ];
};
